import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { ContractViewDialogComponent } from './contract-view-dialog/contract-view-dialog.component';
import { WhatsappSelectionDialogComponent } from './whatsapp-selection-dialog/whatsapp-selection-dialog.component';
import { ContractsListDialogComponent } from './contracts-list-dialog.component';

@NgModule({
  declarations: [
    ContractsListDialogComponent,
    ContractViewDialogComponent,
    WhatsappSelectionDialogComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTableModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    MatDividerModule,
    MatTooltipModule,
    DialogContainerModule,
    MatTabsModule,
    MatSortModule,
    MatPaginatorModule,
    MatChipsModule,
    AngularMaterialModule,
    FieldsModule,
    NgxChartsModule,
  ],
  exports: [
    ContractsListDialogComponent,
    ContractViewDialogComponent,
    WhatsappSelectionDialogComponent
  ],
  providers: [
  ]
})
export class ContractsListDialogModule { }
